// extracted by mini-css-extract-plugin
export var cardHeader = "_ja-1";
export var contentCard = "_ja-0";
export var headerActions = "_ja-3";
export var reorderHandle = "_ja-5";
export var titleArea = "_ja-2";
export var titleAreaWithHandle = "_ja-4";